import { Link } from 'react-router';
import logoImg from '~/assets/icons/logo-full.svg';
import { ButtonLink } from '~/components/new/Button';
import { isStaging } from '~/utils/env';

export default function TopBarPublic({ hideButtons = false }: { hideButtons?: boolean }) {
    return (
        <div className={`topbar topbar-public ${isStaging() ? 'topbar-staging' : ''}`}>
            <Link
                className='topbar-brand'
                to='/'>
                <img
                    src={logoImg}
                    alt='Remotely'
                />
            </Link>
            {!hideButtons && <ButtonLink to='/login'>Sign In</ButtonLink>}
        </div>
    );
}
